import React, { Component } from 'react';
import ReactApexChart from "react-apexcharts";

class CountersSummaryChart extends Component {
    constructor(props) {
        super(props);

        this.state = {
            options: {
                chart: {
                    type: 'bar',
                    height: 280,
                    stacked: true,
                    toolbar: {
                        show: false
                    }
                },
                dataLabels: {
                    enabled: false
                },
                plotOptions: {
                    bar: {
                        columnWidth: "60%",
                    },
                },
                colors: ['#568fff', '#ffea6d', '#b8c0cf', '#ff9952'],
                yaxis: {
                    tickAmount: 16
                },
                xaxis: {
                    axisTicks: { show: false },
                    axisBorder: { show: false },
                    categories: this.props.branchNamesList
                },
                legend: {
                    show: true
                }
            },
            series: [
                {
                    name: "Serving",
                    data: this.props.servingCounters
                },
                {
                    name: "AUX",
                    data: this.props.auxCounters
                },
                {
                    name: "Idle",
                    data: this.props.idleCounters
                },
                {
                    name: "N/A",
                    data: this.props.notAvailableCounters
                }
            ]
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.servingCounters !== this.props.servingCounters 
            || prevProps.auxCounters !== this.props.auxCounters
            || prevProps.idleCounters !== this.props.idleCounters
            || prevProps.notAvailableCounters !== this.props.notAvailableCounters) {
            this.setState({
                options: {
                    chart: {
                        type: 'bar',
                        height: 280,
                        stacked: true,
                        toolbar: {
                            show: false
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    plotOptions: {
                        bar: {
                            columnWidth: "60%",
                        },
                    },
                    colors: ['#568fff', '#ffea6d', '#b8c0cf', '#ff9952'],
                    yaxis: {
                        tickAmount: 16
                    },
                    xaxis: {
                        axisTicks: { show: false },
                        axisBorder: { show: false },
                        categories: this.props.branchNamesList
                    },
                    legend: {
                        show: true
                    }
                },
                series: [
                    {
                        name: "Serving",
                        data: this.props.servingCounters
                    },
                    {
                        name: "AUX",
                        data: this.props.auxCounters
                    },
                    {
                        name: "Idle",
                        data: this.props.idleCounters
                    },
                    {
                        name: "N/A",
                        data: this.props.notAvailableCounters
                    }
                ]
            })
        }
    }
    render() {
        return (
            <div>
                <ReactApexChart
                    options={this.state.options}
                    series={this.state.series}
                    type="bar"
                    height="550px"
                />
            </div>
        );
    }
}

export default CountersSummaryChart;